/**
 * SidebarHeader.jsx — 사이드바 상단 브랜드/사용자 정보 영역 (2026-04-27 신규)
 *
 * SidebarContent.jsx 의 300줄 룰 준수 + 디자인 분리.
 *
 * 디자인:
 *   - 카드 형태: 둥근 사각, 사이드바 톤(pine-800/40 반투명 배경 + pine-700 보더)
 *   - 로고: pine-icon-192-v2.png (회사 PWA 아이콘) — 흰 배경 둥근 컨테이너에 안착 (어두운 로고가 사이드바 배경에 묻히지 않도록)
 *   - 회사명: "(주)파인그룹" 강조
 *   - 부제 분기:
 *       admin    → "관리자 페이지" (작게)
 *       employee → 이름 (강조) + 부서 (작게) — 위장접속 시 위장된 사용자 정보 표시
 *
 * Props:
 *   isAdmin (boolean)            — admin role 여부 (sidebarFilters.isAdminUser 결과)
 *   me ({ name, department, ... }) — useAppPermissions 의 me (위장 시 위장된 사용자)
 */
import React from 'react';

// 테넌트 브랜딩 소스: 회사명 = tenant.displayName > tenant.name > company.name.
//   로고 = tenant.logoUrl(업로드/시드). 없으면 파인 로고 폴백 대신 회사명 머리글자 모노그램
//   (고객 테넌트에 파인그룹 로고가 새는 것 방지).
export default function SidebarHeader({ isAdmin, me }) {
  const brandName = me?.tenant?.displayName || me?.tenant?.name || me?.company?.name || '관리자';
  const logoUrl = me?.tenant?.logoUrl || null;
  return (
    <div className="mx-2.5 mt-3 mb-2 px-3 py-2.5 rounded-xl bg-[var(--bg-subtle)] border border-[var(--border)]">
      <div className="flex items-center gap-2.5 min-w-0">
        {/* 로고: 흰 배경 컨테이너 + 테넌트 로고(없으면 회사명 머리글자) */}
        <div className="w-9 h-9 rounded-lg bg-white border border-[var(--border)] flex items-center justify-center flex-shrink-0 overflow-hidden">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={brandName}
              className="w-7 h-7 object-contain"
              draggable={false}
            />
          ) : (
            <span className="text-pine-700 font-black text-[15px] leading-none">{String(brandName).trim().charAt(0) || '?'}</span>
          )}
        </div>
        {/* 회사명 + 부제 (admin/employee 분기) */}
        <div className="min-w-0 flex-1">
          <div className="text-[13px] font-extrabold text-[var(--text)] leading-tight truncate">{brandName}</div>
          {isAdmin ? (
            <div className="text-[10px] text-[var(--text-muted)] mt-0.5 leading-tight">관리자 페이지</div>
          ) : (
            // 이름 + 부서를 한 줄에 가운뎃점(·)으로 결합 — 로고 높이와 자연스럽게 2줄 균형
            <div className="text-[11px] mt-0.5 leading-tight truncate">
              <span className="font-bold text-accent-600 dark:text-accent-300">{me?.name || '직원'}</span>
              {me?.department && <span className="text-[var(--text-muted)]"> · {me.department}</span>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
